import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import { number } from '@coders-tm/vue-number-format';

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component('number', number);
